import gql from 'graphql-tag';

export const removeSupplierMember = gql`
  mutation supplierMemberRemove($input: IdInput!) {
    supplierMemberRemove(input: $input) {
      success
    }
  }
`;
